import * as Yup from "yup";

export const Name = Yup.string().required("Name is required");
export const Type = Yup.string().required("Type is required");
export const Email = Yup.string()
  .email("Invalid email address")
  .required("Email is required");
export const Password = Yup.string().required("Password is required");
export const Role = Yup.string().required("Select a role");
